import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "./locales/fr.json";
import nl from "./locales/nl.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import legalFr from "./locales/legal_fr.json";
import legalNl from "./locales/legal_nl.json";
import legalEn from "./locales/legal_en.json";
import legalDe from "./locales/legal_de.json";

const merge = (a, b) => ({ ...a, ...b });

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: merge(fr, legalFr) },
      nl: { translation: merge(nl, legalNl) },
      en: { translation: merge(en, legalEn) },
      de: { translation: merge(de, legalDe) },
    },
    fallbackLng: "fr",
    supportedLngs: ["fr", "nl", "en", "de"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "wv_lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
